export default "__VITE_ASSET___Jr31RUx__"